import { Controller } from '@hotwired/stimulus'

// A CSV dropped on the panel opens the upload modal with that file attached, leaving only the fiscal year to pick.
export default class extends Controller {
  static targets = ['trigger']
  static classes = ['dropping']

  connect() {
    document.addEventListener('turbo:frame-load', this.attachPendingFile)
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.attachPendingFile)
  }

  dragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'copy'
    this.element.classList.add(this.droppingClass)
  }

  dragleave(event) {
    if (!this.element.contains(event.relatedTarget)) this.element.classList.remove(this.droppingClass)
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove(this.droppingClass)
    const file = event.dataTransfer.files[0]
    if (!file) return

    this.pendingFile = file
    this.triggerTarget.click()
    this.attachPendingFile({ target: document })
  }

  attachPendingFile = event => {
    const input = this.pendingFile && event.target.querySelector('#oaaps_variance_upload_form input[type="file"]')
    if (!input) return

    const transfer = new DataTransfer()
    transfer.items.add(this.pendingFile)
    input.files = transfer.files
    this.pendingFile = null
  }
}
